import {
  Checkbox,
  createStandaloneToast,
  FormControl,
  Stack,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import React, { FC, useState } from "react";
import {
  CardDetailsFromStripe,
  CARD_IMAGES,
  Platform,
  SUCCESS_TOAST_DURATION,
} from "../common";
import { toCapital } from "../common/utils";
import { Button } from "./Button";
import { LegalText } from "./LegalText";

const toast = createStandaloneToast();
export const PaymentCardItem: FC<{
  cardDetails: CardDetailsFromStripe;
  buttonText: string;
  onCardClick: (paymentId: string) => void;
  loading?: boolean;
  platform: Platform;
}> = (props) => {
  const [isLargerThan900] = useMediaQuery("(min-width: 900px)");
  const [legalStatus, setLegalStatus] = useState(false);
  const { cardDetails, buttonText, onCardClick, loading, platform } = props;

  const handleCardClick = (paymentId: string) => {
    if (!legalStatus) {
      toast({
        title: "Marque la casilla de verificación de términos y condiciones",
        position: "top",
        duration: SUCCESS_TOAST_DURATION,
        status: "warning",
      });
    } else {
      onCardClick(paymentId);
    }
  };

  // @ts-expect-error
  const Icon = CARD_IMAGES[cardDetails.brand];
  return (
    <Stack direction={"column"} spacing={"2"} align="flex-start">
      <Text textStyle={isLargerThan900 ? "bodyHeavy" : "bodyHeavyMobile"}>
        {toCapital(cardDetails.brand)}
      </Text>
      <Stack direction={"row"} spacing={"8"} align="center">
        <Stack direction="row" align="center">
          <Icon width="40px" />
          <Text textStyle="body">**** {cardDetails.last4}</Text>
        </Stack>
        <Text>
          Caduca {String(cardDetails.exp_month).length === 1 ? "0" : ""}
          {cardDetails.exp_month}/{cardDetails.exp_year}
        </Text>
      </Stack>
      <Stack spacing="8">
        <FormControl>
          {platform ? (
            <FormControl isRequired>
              <Stack direction="row" align="flex-start" spacing="0">
                <Checkbox
                  name="legalCheckbox"
                  onChange={(e) => setLegalStatus(e.target.checked)}
                />
                <LegalText platform={platform} />
              </Stack>
            </FormControl>
          ) : null}
        </FormControl>
        <Button
          onClick={() => handleCardClick(cardDetails.id)}
          variant="pulpo"
          isLoading={loading}
          width="200px"
        >
          {buttonText}
        </Button>
      </Stack>
    </Stack>
  );
};
